import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-relay';

import GiftcardCard from './GiftcardCard';
import QueryHandler from '../../misc/QueryHandler';

const GiftcardCardQueryRenderer = (props) => {
  const { eventId, eventBanner, eventName } = props;

  return (
    <QueryHandler
      query={graphql`
        query GiftcardCardQueryRendererQuery($eventId: ID!) {
          viewer {
            ...GiftcardCard_viewer
          }
        }
      `}
      variables={{
        eventId: eventId,
      }}
      render={(props) => {
        return (
          <GiftcardCard
            viewer={props.viewer}
            eventBanner={eventBanner}
            eventName={eventName}
            eventId={eventId}
          />
        );
      }}
    />
  );
};

GiftcardCardQueryRenderer.propTypes = {
  eventId: PropTypes.string,
  eventBanner: PropTypes.string,
  eventName: PropTypes.string,
};

export default GiftcardCardQueryRenderer;
